<template>
	<o-page
		title="Tableau de bord"
		class="orion-page--full-width">
		<div class="row row--grid">
			<div class="col-xs-12">
				<o-card>
					<o-carousel
						:key="setup.stepTimer"
						v-model="setup.modelValue"
						:carousel-step="1"
						:step-timer="setup.stepTimer"
						hide-navigation-buttons
						pause-on-hover>
						<o-carousel-item
							v-if="setup.self.isAgency()"
							:key="1"
							name="companyCode">
							<carousel-company-code/>
						</o-carousel-item>

						<o-carousel-item
							:key="2"
							name="organization">
							<carousel-organization/>
						</o-carousel-item>

						<o-carousel-item
							:key="3"
							name="marketing">
							<carousel-marketing-module
								style="min-width: 100%"
								title="Nouveau module de commandes disponible !"
								img="order">
								<template
									v-if="setup.self.isAgency()"
									#caption>
									<p>
										Gagnez en efficacité dans la gestion des besoins de vos clients <br v-if="!setup.ui.onLayoutNavBottom">
										grâce à notre <strong class="text--brand">
											nouveau module de suivi de commandes.
										</strong>
									</p>
								</template>

								<template
									v-else
									#caption>
									<p>
										Gagnez en efficacité dans la gestion de vos
										besoins <br v-if="!setup.ui.onLayoutNavBottom">
										grâce à notre <strong class="text--brand">
											nouveau module de commandes.
										</strong>
									</p>
									<p>
										Vos agences ont désormais à leur disposition une gamme complète d'outils <br>
										pour suivre vos commandes, positionner des candidats et vous <br>
										les partager en quelques clics !
									</p>
								</template>

								<template #actions>
									<o-button
										v-if="setup.self.can('OrderCreate')"
										color="brand"
										suffix-font-icon="icon-interface-arrows-button-right"
										@click="setup.createOrder()">
										Créer une commande
									</o-button>
									<o-button
										v-if="setup.self.can('Plugin') && setup.self.isAgency()"
										color="info"
										outline
										prefix-font-icon="icon-interface-unlock"
										@click="setup.openUnlockOrderAside()">
										Débloquer le module
									</o-button>
								</template>
								<template
									v-if="setup.self.isAgency()"
									#warn>
									<span
										class="text--warning"
										style="font-size: 12px">
										<o-icon
											font-icon="icon-interface-alert-information-circle"
											style="margin-right: 2px"/>
										Sans abonnement, vous disposez de 5 commandes offertes par agence.
									</span>
								</template>
							</carousel-marketing-module>
						</o-carousel-item>
					</o-carousel>
				</o-card>
			</div>

			<template v-if="setup.self.isAgency()">
				<div
					v-if="setup.self.can('SignatureManagement')"
					class="col-xs-12">
					<dashboard-signature-balance-alert/>
				</div>

				<div class="col-sm-6 col-md-4">
					<dashboard-new-doc-or-sign-card
						type="notSigned"
						color="info"/>
				</div>

				<div class="col-sm-6 col-md-4">
					<dashboard-new-doc-or-sign-card
						type="notSigned"
						late
						color="warning"/>
				</div>

				<div class="col-sm-6 col-md-4">
					<dashboard-orders-main-card color="success"/>
				</div>
			</template>

			<template v-else-if="setup.self.isClient()">
				<div
					class="col-sm-6"
					:class="setup.cardsLayoutClass">
					<dashboard-new-doc-or-sign-card
						type="notViewed"
						color="success"/>
				</div>

				<div
					class="col-sm-6"
					:class="setup.cardsLayoutClass">
					<dashboard-new-doc-or-sign-card
						type="notSigned"
						color="info"/>
				</div>

				<div
					v-if="setup.self.can('TimeTicketRead')"
					class="col-sm-6 col-lg-4">
					<dashboard-time-ticket-to-fill-card/>
				</div>
			</template>
		</div>
	</o-page>
</template>
<script setup lang="ts">
import DashboardCompanySetupService from '@/setup/dashboard/DashboardCompanySetupService';
import DashboardSignatureBalanceAlert from '@/components/dashboard/DashboardSignatureBalanceAlert.vue';
import DashboardOrdersMainCard from '@/components/dashboard/DashboardOrdersMainCard.vue';
import DashboardNewDocOrSignCard from '@/components/dashboard/DashboardNewDocOrSignCard.vue';
import DashboardTimeTicketToFillCard from '@/components/dashboard/DashboardTimeTicketToFillCard.vue';
import CarouselCompanyCode from '@/components/carousel/CarouselCompanyCode.vue';
import CarouselOrganization from '@/components/carousel/CarouselOrganization.vue';
import CarouselMarketingModule from '@/components/carousel/CarouselMarketingModule.vue';
const setup = new DashboardCompanySetupService();
</script>

